let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hvq1G")).then(() => parcelRequire('lt9Ls'));